/**
 * defaultOnlineProposalTemplate.ts — Modelo inicial da Proposta Online
 *
 * A Proposta Online é a proposta em formato de site, entregue pelo link privado
 * do negócio (token, sem indexação). Nasce com a mesma estrutura da proposta
 * pública atual, podendo receber blocos visuais de página depois.
 *
 * RELEASE: v1.0.0 - 2026-09-10 - Versão inicial (Studio, Proposta Online)
 */

import { STUDIO_SCHEMA_VERSION, type StudioDocument } from '@/lib/studio/core';

/** Documento inicial de um modelo do tipo Proposta Online. */
export const DEFAULT_ONLINE_PROPOSAL_DOCUMENT: StudioDocument = {
  schemaVersion: STUDIO_SCHEMA_VERSION,
  theme: { maxWidth: '960px' },
  settings: { stickyBar: true },
  blocks: [
    { id: 'hero', type: 'proposal.hero', props: {} },
    { id: 'status', type: 'proposal.status', props: {} },
    { id: 'items', type: 'proposal.items', props: {} },
    { id: 'totals', type: 'proposal.totals', props: {} },
    { id: 'conditions', type: 'proposal.conditions', props: {} },
    { id: 'decision', type: 'action.proposal.decision', props: {} },
    { id: 'footer', type: 'proposal.footer', props: {} },
  ],
};
